import { ReferenceDataService } from '@lib/services/reference-data.service';
import { of } from 'rxjs';
import { eqOperator } from '../../filtre-investisseur-helper';
import { CompositeFiltreCustomBuilder, FiltreBuilder } from '../filtre-builder.model';

export function getCoordonneesBuilders(referenceDataService: ReferenceDataService): FiltreBuilder[] {
  return [
    new CompositeFiltreCustomBuilder(
      'COORDONNEES',
      'PHYSIQUE_ADRESSE_MODE_LOGEMENT',
      'atlasInvestisseur.investisseurPersonnePhysiques.some.personnePhysique.personnePhysiqueAdresses.some.adresse.and',
      'modeLogement',
      eqOperator,
      'Select',
      of(referenceDataService.modeLogementOptionsSelect),
      [{ fieldPath: 'typeAdresseCode', operator: 'eq', value: 'DOM' }]
    ),
  ];
}
